module.exports = __webpack_public_path__ + "img/user.8a772275.png";